module.exports = __webpack_public_path__ + "img/0Q3A5767_L_WoodMatted.0b1d0a10.jpg";